type KeyboardKeys = {
  esc: number;
  enter: number;
};

export const keyboardKeys: KeyboardKeys = {
  esc: 27,
  enter: 13
} as const;
